import { useContext, useState } from 'react';
import ResetPasswordForm from "./Form";
import { AuthContext } from '../../Context/Auth';
import { requestResetPasswordAction } from '../../Context/Auth/actions';

import Loader from '../../Components/Lottie';
import loader from '../../Assets/json/spinner.json';


const ResetPassword = ({
  shouldLogin,
  googleAuthHandler,
  shouldResetPassword,
}) => {
  const {
    dispatch,
    authState: { requestingPasswordReset },
  } = useContext(AuthContext);

  const [isRequestSuccessful, setRequestSuccessful] = useState(false);

  const resetPasswordHandler = async (params) => {
    const response = await dispatch(requestResetPasswordAction(params));
    setRequestSuccessful(!!response);
  };

  return (
    <>
      <div>
        <h6 className="leading-7 text-base tracking-widest md:text-lg md:leading-34 md:tracking-wide">
          Forgot Password?
        </h6>
        {!isRequestSuccessful && (
          <span className="text-10px leading-5 tracking-widest md:text-12 md:leading-snug">
            Enter the <span className="font-semibold">email address</span>, you
            registered with to reset your password.
          </span>
        )}
        {isRequestSuccessful && (
          <span className="text-10px leading-5 tracking-widest md:text-12 md:leading-snug">
            <span className="font-bold text-chestNut">
              Please Check Your Email.
            </span>{" "}
            If you have an account with us, you would receive an email to reset
            your password.
          </span>
        )}
      </div>
      <div className="pt-5 md:pt-6">
{ !isRequestSuccessful &&       <ResetPasswordForm
          loading={requestingPasswordReset}
          resetPasswordHandler={resetPasswordHandler}
        />}
        <span className="w-full flex justify-end  text-seal text-xs font-poppins tracking-wide mt-2">
          <button
            onClick={shouldLogin}
            className="py-2 px-3 outline-none focus:outline-none"
          >
            Log in
          </button>
        </span>
      </div>
    </>
  );
};

export default ResetPassword;